import React from 'react';
import AdminArenaQueueTable from '../../../components/RoboticsNetworks/RoboticsQueueTables/AdminArenaQueueTable';
import RoboticsLayout from '../../../components/RoboticsNetworks/RoboticsLayout/RoboticsLayout'
import { useAxios } from '../../../utils/Axios';
import { useEffect, useState, useContext } from 'react';
import Context from '../../../store/Context'
import { ToastContainer, Zoom } from 'react-toastify';


const AdminArenaQueue = (props) => {

	const [expQueue, setExpQueue] = useState([]);

	const axiosInstance = useAxios();
	const { state, actions } = useContext(Context);

	useEffect(() => {
		fetchExpQueue();
	}, [axiosInstance]);

	const fetchExpQueue = () => {

		if (axiosInstance) {
			actions({ type: 'setState', payload: { ...state, blocking: true } })
			axiosInstance
				.get(`${process.env.REACT_APP_ROBOT_EXPERIMENT_URL}/robotarena-queue`)
				.then((response) => {
					// console.log(response);
					setExpQueue(response.data);
					actions({ type: 'setState', payload: { ...state, blocking: false } })
				})
				.catch((err) => {
					// console.log(err);
					setExpQueue([{"id" : "123","robotCount":"20","duration": 30,"status": 'running'},{"id" : "456","duration": 20,"robotCount":"30","status": 'pending'},{"id" : "789","duration": 20,"robotCount":"50","status": 'cancelled'}])
					actions({ type: 'setState', payload: { ...state, blocking: false } })
				});

		}
	};

	//To refresh Exp Queue list after 2 seconds when event is called 
	const handleSubmit = (flag) => {
		// console.log(flag);
		if (flag) {

			const timer = setTimeout(() => {
				fetchExpQueue();
			}, 2000);

		};
	};

	return (
		<>
			<RoboticsLayout>
				<div className="col-md-12 col-sm-12 col-lg-12 no-padding">
					<div className="default-main-page">
						<>
							{expQueue.length > 0 ? (
								<>
									<div className="project-table-group">
										<AdminArenaQueueTable  data={expQueue} status={handleSubmit}/>
									</div>
								</>
							) : (
									<div className="default-content-center" style={{ margin: '3%' }}>
										You don't have Arena Experiment Queue
									</div>
								)}
						</>
					</div>
				</div>
			</RoboticsLayout>
			<ToastContainer draggable={false} transition={Zoom}/>
		</>
	)
}

export default AdminArenaQueue;